module.exports = __webpack_public_path__ + "img/photo-53.3fcfdb1b.webp";